import { useEffect } from 'react'
import { isDeveloperEmail } from '@feedyou/utils'
import { SocketLog } from '../../../lib/debugging/socketLog'

import { useUserInfo } from '../../../store/user'
import { inDevNodeEnv, inStorybook, inTestNodeEnv } from '../../../lib/runtimeEnvironments'

export const useIsDebugEnabled = () => {
  const { email } = useUserInfo()

  const result =
    inTestNodeEnv() ||
    inStorybook() ||
    inDevNodeEnv() ||
    isDeveloperEmail(email) ||
    !!window.Cypress

  useEffect(() => SocketLog.setEnabled(result), [result])

  return result
}
